import React from 'react';
import styled from 'styled-components/macro';

interface Props {
	children: React.ReactNode;
	to: number;
	currentPage: number;
	setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
	satelliteTracker: () => void;
}

const NavElement = ({ children, to, currentPage, setCurrentPage, satelliteTracker }: Props) => {
	// Determine if this NavElement's path matches the current path
	const isCurrentPage = currentPage === to;

	// Navigate to the designated page
	const clickHandler = () => {
		satelliteTracker();
		setCurrentPage(to);
	};

	return (
		<StyledNavElement>
			<StyledLink onClick={clickHandler} className={isCurrentPage ? 'active' : ''}>
				{children}
			</StyledLink>
		</StyledNavElement>
	);
};

const StyledNavElement = styled.span`
	display: inline-flex;
	align-items: center;
`;

const StyledLink = styled.button`
	border: none;
	background-color: unset;
	display: inline;
	font-family: museo-sans;
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 15px;
	color: #333333;
	text-decoration: none;
	z-index: 1;
	padding: 12px 2px 12px 2px;

	&.active {
		border-bottom: 3px solid #e81111;
	}
	&:hover {
		color: #e81111;
		font-weight: 600;
		cursor: pointer;
	}
	&:active {
		color: #b90000;
		font-weight: 600;
	}
	&:focus-visible {
		color: #e81111;
		font-weight: 600;
		border: 2px solid #e81111;
		border-radius: 4px;
		outline: none;
	}
`;

export default NavElement;
